export default __webpack_public_path__ + "static/media/healthcare-global.ab027f46.jpg";